export default __webpack_public_path__ + "static/media/defaultQrCodeDisabled.0b1b8295.png";